
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cross-platform-development-services",
      function () {
        return require("private-next-pages/cross-platform-development-services.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cross-platform-development-services"])
      });
    }
  